import React, { useState } from 'react';

import type { ReactNode } from 'react';

import { CreateCourseModalContainer } from 'Courses/components/forms';

import { ApplicationWrapper, ContentWrapper } from './AppLayout.styles';
import { Footer } from './Footer';
import { Navbar } from './Navbar';

type Props = {
  isForLogged: boolean;
  children: ReactNode;
};

export const AppLayout = ({ isForLogged, children }: Readonly<Props>) => {
  const [showCreateCourseModal, setShowCreateCourseModal] = useState(false);

  const handleOpenCreateCourseModal = () => {
    setShowCreateCourseModal(true);
  };

  const handleCloseCreateCourseModal = () => {
    setShowCreateCourseModal(false);
  };

  return (
    <ApplicationWrapper>
      <Navbar isForLogged={isForLogged} onCreateCourse={handleOpenCreateCourseModal} />
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />

      {/* Global Create Course Modal */}
      <CreateCourseModalContainer
        open={showCreateCourseModal}
        onClose={handleCloseCreateCourseModal}
      />
    </ApplicationWrapper>
  );
};
